import { Button, Flex, Input, InputProps } from "@chakra-ui/react";
import { useRouter } from "next/navigation";
import { FormEvent, useState } from "react";
import { z } from "zod";

const emailSchema = z.string().email();

export function SubscribeForm({ ...props }: InputProps) {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const disableButton = () => {
    try {
      emailSchema.parse(email); // throws if invalid
      return false;
    } catch (e) {
      return true;
    }
  };
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    return fetch("/api/waitlist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setIsLoading(false);
        if (res.success) {
          setEmail("");
        }
        sessionStorage.setItem(
          "newsletterConfirmation",
          JSON.stringify({
            title: res.title,
            description: res.subtitle,
            status: res.success,
          }),
        );
        router.push(`/individuals/newsletter-confirmation`);
      })
      .catch((e) => console.error(e));
  };
  return (
    <form onSubmit={handleSubmit}>
      <Flex
        h="55px"
        w={{
          base: "fit-content",
          lg: "520px",
        }}
        borderRadius="32px"
        borderWidth="1px"
        bg="white"
        shadow="lg"
      >
        <Input
          h="full"
          borderLeftRadius="inherit"
          border="0px"
          type="email"
          placeholder="Enter your email"
          bg="white"
          px="24px"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          {...props}
          _focus={{
            outline: "none",
            border: "none",
          }}
          _focusVisible={{
            outline: "none",
            border: "none",
          }}
        />
        <Button
          h="inherit"
          w="fit-content"
          px="50px"
          borderRadius="inherit"
          bg="blue.500"
          color="white"
          fontSize={{
            base: "14px",
            md: "16px",
            lg: "17px",
            xl: "18px",
          }}
          _hover={{
            bgColor: "blue.600",
          }}
          fontWeight="bold"
          type="submit"
          isLoading={isLoading}
          disabled={disableButton()}
        >
          Subscribe
        </Button>
      </Flex>
    </form>
  );
}
